import SkuItemFaq from './SkuItemFaq';

export default SkuItemFaq;
